import script from "./FLogout.vue?vue&type=script&setup=true&lang=ts"
export * from "./FLogout.vue?vue&type=script&setup=true&lang=ts"

import "./FLogout.vue?vue&type=style&index=0&id=ad1a5b00&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad1a5b00"]])

export default __exports__